/**
 * Kontaktformular: Vorauswahl per URL-Parameter
 *
 * Hooks:
 *   <select data-prefill-param="thema" [data-prefill-scroll="true"]>
 *     <option value="Label" data-alias="kuerzel">
 *   <input type="hidden" data-prefill-param="quelle">
 *
 * Matching-Reihenfolge fuer Selects: data-alias -> exakter Wert -> Teilstring.
 * Kein Treffer = Platzhalter bleibt stehen.
 */
(function () {
  'use strict';

  function normalize(value) {
    return String(value)
      .toLowerCase()
      .replace(/\u00e4/g, 'ae')
      .replace(/\u00f6/g, 'oe')
      .replace(/\u00fc/g, 'ue')
      .replace(/\u00df/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findOption(select, wanted) {
    var options = select.options;
    var i;

    for (i = 0; i < options.length; i++) {
      if (options[i].dataset.alias && normalize(options[i].dataset.alias) === wanted) {
        return options[i];
      }
    }

    for (i = 0; i < options.length; i++) {
      if (options[i].value && normalize(options[i].value) === wanted) {
        return options[i];
      }
    }

    if (wanted.length >= 3) {
      for (i = 0; i < options.length; i++) {
        if (options[i].value && normalize(options[i].value).indexOf(wanted) !== -1) {
          return options[i];
        }
      }
    }

    return null;
  }

  function init() {
    if (typeof URLSearchParams === 'undefined') {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var scrollTarget = null;

    Array.prototype.forEach.call(
      document.querySelectorAll('select[data-prefill-param]'),
      function (select) {
        if (select.dataset.prefillDone === '1') {
          return;
        }

        var raw = params.get(select.dataset.prefillParam);

        if (!raw) {
          return;
        }

        var match = findOption(select, normalize(raw));

        if (!match) {
          return;
        }

        select.value = match.value;
        select.dataset.prefillDone = '1';
        select.dispatchEvent(new Event('change', { bubbles: true }));

        if (select.dataset.prefillScroll === 'true' && !scrollTarget) {
          scrollTarget = select.closest('.shopify-section') || select.closest('form');
        }
      }
    );

    Array.prototype.forEach.call(
      document.querySelectorAll('input[type="hidden"][data-prefill-param]'),
      function (input) {
        if (input.dataset.prefillDone === '1') {
          return;
        }

        var raw = params.get(input.dataset.prefillParam);

        if (raw) {
          input.value = raw.slice(0, 255);
          input.dataset.prefillDone = '1';
        }
      }
    );

    if (scrollTarget && !window.location.hash) {
      window.requestAnimationFrame(function () {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  if (!window.__sinobContactPrefillBound) {
    window.__sinobContactPrefillBound = true;
    document.addEventListener('shopify:section:load', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
